import Head from 'next/head';
import { useSelector } from 'react-redux';
import { NextSeo } from 'next-seo';
import ProdigyContainer from '@cont/Prodigy/ProdigyContainer';
import { fetchTestSeriesData } from '@actions/quizzes';

const TestSeries = () => {
  const data = useSelector(({ quizzes }) => quizzes.testSeries?.UCL || null);
  const { metaData = {} } = data;
  const { title, description, ogImageURL, twitterImageURL } = metaData;
  return (
    <>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          title,
          description,
          images: [
            {
              url: ogImageURL
            }
          ]
        }}
        twitter={{
          images: [{ url: twitterImageURL }]
        }}
      />
      <Head>
        <title>{metaData.title}</title>
      </Head>
      <ProdigyContainer data={data} />
    </>
  );
};

TestSeries.getInitialProps = async ({ store }) => {
  if (!store.getState().quizzes.testSeries?.UCL) {
    await store.dispatch(fetchTestSeriesData('UCL'));
  }
};

TestSeries.pageInfo = {
  name: 'Unacademy UCL',
  layoutOptions: {
    hideSearch: true,
    hideGoalSelector: true,
    hideLearnerMinutes: true,
    hideNudges: true,
    disableDarkMode: true,
    useFreeLayout: true,
    hideIntercom: true,
    hideFreshbot: true
  }
};

export default TestSeries;
